// ============================================================================
// SEED / DEMO MEMBER PROFILES
// ----------------------------------------------------------------------------
// These are placeholder member profiles shown in the Member Directory so it
// doesn't look empty while real membership grows. They are intentionally kept
// in ONE file, each with an `isSeed: true` flag and a `seed-*` id, so they are
// easy to find and DELETE as real members sign up.
//
// To remove a seed member: delete its entry from SEED_MEMBERS below.
// To remove ALL seeds (once you have enough real members): export an empty array.
//
// Real members come from Firestore (`users` collection). Seed members never
// touch the database — they exist only here.
// ============================================================================

export const SEED_MEMBERS = [
  {
    id: 'seed-1', isSeed: true,
    firstName: 'John', lastName: 'Smith',
    title: 'Investment Banking Associate', company: 'Goldman Sachs',
    location: 'New York, NY', specialty: 'Investment Banking',
    image: '', linkedinUrl: 'https://www.linkedin.com/in/john-smith-apn',
    bio: 'Investment banking associate focused on M&A advisory across technology and industrials. Active in the APN community connecting deal professionals.',
    memberSince: 'March 2019',
    isFoundingMember: true, isVipMember: false, referralCount: 0, role: '', chapter: 'New York', ambassadorSince: null,
  },
  {
    id: 'seed-2', isSeed: true,
    firstName: 'Sarah', lastName: 'Johnson',
    title: 'Private Equity Analyst', company: 'Blackstone',
    location: 'New York, NY', specialty: 'Private Equity',
    image: '',
    bio: 'Private equity analyst evaluating buyout opportunities in healthcare and consumer. Passionate about building a stronger network of M&A professionals.',
    memberSince: 'June 2023',
    isFoundingMember: false, isVipMember: true, referralCount: 5, role: '', chapter: 'New York', ambassadorSince: null,
  },
  {
    id: 'seed-3', isSeed: true,
    firstName: 'Michael', lastName: 'Chen',
    title: 'VP of Corporate Development', company: 'Morgan Stanley',
    location: 'Chicago, IL', specialty: 'Corporate Development',
    image: '',
    bio: 'Leads corporate development and strategic acquisitions. Long-time APN member and ambassador who loves connecting people across the deal ecosystem.',
    memberSince: 'May 2018',
    isFoundingMember: false, isVipMember: false, referralCount: 12, role: '', chapter: 'Chicago', ambassadorSince: 'June 2020',
  },
  {
    id: 'seed-4', isSeed: true,
    firstName: 'Emily', lastName: 'Rodriguez',
    title: 'Tax Manager', company: 'Deloitte',
    location: 'Los Angeles, CA', specialty: 'Accounting',
    image: '',
    bio: 'Tax manager specializing in transaction structuring and due diligence. Chapter President for the APN Los Angeles community.',
    memberSince: 'June 2023',
    isFoundingMember: false, isVipMember: false, referralCount: 0, role: 'Chapter President', chapter: 'Los Angeles', ambassadorSince: null,
  },
  {
    id: 'seed-5', isSeed: true,
    firstName: 'David', lastName: 'Kim',
    title: 'Associate Attorney', company: 'Skadden',
    location: 'Boston, MA', specialty: 'Law Firm',
    image: '',
    bio: 'M&A attorney advising on complex cross-border transactions. Founding member of the APN community.',
    memberSince: 'June 2023',
    isFoundingMember: true, isVipMember: false, referralCount: 0, role: '', chapter: 'Boston', ambassadorSince: null,
  },
  {
    id: 'seed-6', isSeed: true,
    firstName: 'Jessica', lastName: 'Lee',
    title: 'Investment Banking Analyst', company: 'JP Morgan',
    location: 'San Francisco, CA', specialty: 'Investment Banking',
    image: '', linkedinUrl: 'https://www.linkedin.com/in/jessica-lee-apn',
    bio: 'Investment banking analyst covering technology and software. Enthusiastic about mentorship and growing the next generation of dealmakers.',
    memberSince: 'June 2023',
    isFoundingMember: false, isVipMember: true, referralCount: 0, role: '', chapter: 'San Francisco', ambassadorSince: null,
  },
  {
    id: 'seed-7', isSeed: true,
    firstName: 'Robert', lastName: 'Wilson',
    title: 'Director', company: 'KPMG',
    location: 'Dallas, TX', specialty: 'Accounting',
    image: '',
    bio: 'Director in transaction services with over a decade advising on buy-side and sell-side diligence. Long-standing member of APN.',
    memberSince: 'January 2015',
    isFoundingMember: false, isVipMember: false, referralCount: 0, role: '', chapter: 'Dallas', ambassadorSince: null,
  },
  {
    id: 'seed-8', isSeed: true,
    firstName: 'Amanda', lastName: 'Thompson',
    title: 'Wealth Management Associate', company: 'UBS',
    location: 'Miami, FL', specialty: 'Wealth Manager',
    image: '',
    bio: 'Wealth management associate helping business owners plan around liquidity events. Active APN ambassador in the Southeast.',
    memberSince: 'June 2023',
    isFoundingMember: false, isVipMember: false, referralCount: 7, role: '', chapter: 'Miami', ambassadorSince: 'January 2024',
  },
];

// Look up a single seed member by its `seed-*` id (used by the profile page).
export const getSeedMemberById = (id) => SEED_MEMBERS.find((m) => m.id === id) || null;
